import React, {Component} from "react"
import {Link, browserHistory} from "react-router"
import {Button} from "elemental"

import FormCMS from "theme/components/Form/FormCMS"

export default class NewCustomerPage extends Component {

  render() {
    return (
      <div>
        <div className="pa3">
          <Link to="/login"> <Button><i className="icon icon-angle-left" name="chevron left"/> zurück zur Anmeldung</Button></Link>
        </div>
        <div className="mw7 center pt2 pb6">
          <div className="tc pb4">
            <Link to="/login">
              <img src="/logo.png" title="Zur Startseite"/>
            </Link>
          </div>

          <FormCMS slug={"customer_registration"} onSuccess={() => {
            browserHistory.push( "/login" )
            window.swal( "Neukundenanmeldung erhalten", "Vielen Dank für ihre Anmeldung. Sie erhalten Ihre Anmeldedaten per E-Mail",
              "success" )
          }}/>
        </div>
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/theme/pages/NewCustomerPage.js